import React from "react";
import i18n from "i18next";
import AppService from "@service/AppService/AppService";
import Hint from "@components/hint/HintComponent";
import { AuthContext } from "../../../../AuthContext";
import { v4 as uuidv4 } from "uuid";
import { getTranslatedTextIfNeeded } from "../../../../shared/InternationalizationTextUtils";
import { surveyQuestionMethods } from "../../../../shared/Questions/Questions";

const filenameFromUrl = (url) => {
    if (!url) return "";
    try {
        const { pathname } = new URL(url);
        return pathname.substring(pathname.lastIndexOf("/") + 1) || "";
    } catch (e) {
        return "";
    }
};

class UploadComponent extends React.Component {
    static contextType = AuthContext;
    constructor(props) {
        super(props);
        this.onFileChange = this.onFileChange.bind(this);
        this.setSelectedValue = this.setSelectedValue.bind(this);
        this.showFileDialog = this.showFileDialog.bind(this);
        this.fileInputRefs = {};
        this.state = { showProgress: false, fileNames: {} };
    }

    getFileInputRef(answerId) {
        if (!this.fileInputRefs[answerId]) {
            this.fileInputRefs[answerId] = React.createRef();
        }
        return this.fileInputRefs[answerId];
    }

    showFileDialog(answerId) {
        const ref = this.fileInputRefs[answerId];
        if (ref && ref.current) {
            ref.current.click();
        }
    }

    onFileChange(e, a) {
        const { question } = this.props;
        const data = e.target.files;
        if (e.target.files[0] != null) {
            this.setState((prev) => ({
                showProgress: true,
                fileNames: { ...prev.fileNames, [a.id]: data[0].name }
            }));
            const filename = this.generateFilename(data[0].name.split(".").pop());
            this.uploadSingle(data[0], filename, true, () => this.createSingleUploadAnswer(filename, a, question.id), a.id);
        }
    }

    uploadSingle(file, filename, original, onComplete, answerId) {
        const userId = AppService.accountType === "admin" ? AppService.edId : this.context.user.id;
        AppService.getSingleUploadURL(filename, original, userId)
            .then((resp) => {
                return fetch(resp.data.uploadURL, {
                    method: "PUT",
                    body: file
                });
            })
            .then((uploadResponse) => {
                if (uploadResponse.status === 200) {
                    onComplete && onComplete();
                } else {
                    this.handleUploadError(undefined, answerId);
                }
            })
            .catch((error) => {
                this.handleUploadError(error, answerId);
            });
    }

    handleUploadError(error, answerId) {
        this.setState((prev) => {
            const fileNames = { ...prev.fileNames };
            if (answerId !== undefined) {
                delete fileNames[answerId];
            }
            return { showProgress: false, fileNames };
        });
        if (answerId !== undefined) {
            const inputRef = this.fileInputRefs[answerId];
            if (inputRef && inputRef.current) {
                inputRef.current.value = "";
            }
        }
        surveyQuestionMethods.showNotificationWithError(error || i18n.t("upload-failed") || "Upload failed");
    }
    createSingleUploadAnswer(filename, answer, questionId) {
        const { selectedTopic, question, onAnswer } = this.props;
        const res = AppService.uploadSinglePhoto(filename, answer.id, questionId);
        Promise.resolve(res)
            .then((result) => {
                if (result) {
                    this.setSelectedValue(result.data, answer.id);
                    onAnswer(selectedTopic, question, answer);
                }
            })
            .catch((error) => {
                this.handleUploadError(error, answer.id);
            })
            .finally(() => {
                this.setState({ showProgress: false });
            });
    }
    generateFilename(fileType) {
        return uuidv4() + "." + fileType;
    }

    setSelectedValue(answer, answerId) {
        const answerIndex = this.props.question.answers.findIndex((a) => a.id === answerId);
        this.props.question.answers[answerIndex].userAnswer = answer;
    }

    render() {
        const { question, showOverlay } = this.props;

        const answers = question.answers.map((a, i) => {
            const userAnswerText = this.state.fileNames[a.id] || filenameFromUrl(a.userAnswer);
            const answer = (
                <div key={i}>
                    <input
                        id="upload"
                        ref={this.getFileInputRef(a.id)}
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            this.onFileChange(e, a);
                        }}
                        className="fileUploader"
                    />
                    <input
                        type="text"
                        placeholder={getTranslatedTextIfNeeded(a.text)}
                        onClick={() => this.showFileDialog(a.id)}
                        readOnly={true}
                        value={userAnswerText}
                        onChange={() => {}}
                    />
                </div>
            );
            return answer;
        });
        return (
            <div className={`survey-question ${this.props.className}`}>
                {this.props.readonly ? <div className="answer-overlay" /> : null}
                {this.state.showProgress ? <div className={`animated-gradient-surrogate`} /> : null}
                {showOverlay ? <div className="survey-overlay" /> : null}
                <div className="question-text">{getTranslatedTextIfNeeded(question.text)}</div>
                <div className="question-answers">
                    <div className="content">{answers}</div>
                </div>
                <Hint hint={getTranslatedTextIfNeeded(question.hint)} />
            </div>
        );
    }
}

export default UploadComponent;
